import type { PropsWithChildren } from "react"
import { useEffect } from "react"
import posthog from "posthog-js"
import { PostHogProvider as PHProvider } from "posthog-js/react"

import { env } from "@/env"
import { useSession } from "./session"

posthog.init(env.VITE_POSTHOG_KEY, {
	// If you’d like to test Posthog feature flags locally, uncomment the line below
	// and make sure the flags exists in the `Staging` environment in Posthog
	// https://eu.posthog.com/project/14552/feature_flags
	// api_host: `https://eu.posthog.com`,
	api_host: `${env.VITE_API_URL}/ingest`,
	respect_dnt: false,
})

export const analytics = {
	track: (name: string, props?: Record<string, unknown>) => {
		posthog.capture(name, props)
	},
}

export function PosthogProvider({ children }: PropsWithChildren<unknown>) {
	const { session } = useSession()

	useEffect(() => {
		if (
			session?.userId &&
			session?.workspaceId &&
			session?.workspaceName &&
			!session.impersonatingFromUserId
		) {
			// Sentry.setUser({
			// 	id: session.userId,
			// 	email: session.email,
			// 	username: session.name,
			// })
			posthog.identify(session.userId, {
				name: session.name,
				email: session.email,
				workspaceId: session.workspaceId,
				workspaceName: session.workspaceName,
				organizationId: session.workspaceId,
				organizationName: session.workspaceName,
			})
			posthog.group("workspace", session.workspaceId, {
				id: session.workspaceId,
				name: session.workspaceName,
				logoUrl: session.workspaceLogoUrl,
			})
			posthog.group("organization", session.workspaceId, {
				id: session.workspaceId,
				name: session.workspaceName,
				logoUrl: session.workspaceLogoUrl,
			})
		}
	}, [session])

	return <PHProvider client={posthog}>{children}</PHProvider>
}
